import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';
import { Shell } from '@/app/Shell';
import { loadSession } from '@/lib/auth';

/**
 * The authenticated layout. Everything except /login lives under it.
 *
 * `beforeLoad` resolves the session once and caches it, so a deep link
 * (`/orders/1042`) either renders straight into the shell or bounces to login
 * with the destination preserved — never a flash of empty chrome.
 */
export const Route = createFileRoute('/_app')({
  beforeLoad: async ({ context, location }) => {
    const user = await loadSession(context.queryClient);
    if (!user) {
      throw redirect({
        to: '/login',
        search: { redirect: location.href },
      });
    }
    return { user };
  },
  component: () => (
    <Shell>
      <Outlet />
    </Shell>
  ),
});
